import API from "shared/services/Api";
import { IAppraisal } from "shared/types/Appraisal";
import { IAvaliationResponse } from "shared/types/Avaliation";

export const sendAppraisal = async (data: IAppraisal) =>
  API.post("oc/appraisal", data);

export const getAppraisal = async (
  id: string,
  idPac: number
): Promise<IAvaliationResponse> =>
  API.get(`oc/appraisal?id=${id}&pac_id=${idPac}`);
